import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../components/Modal";
import { IdeaGenerationProgress } from "../../components/ideas/IdeaGenerationProgress";

export default function IdeasPopulatingModal({ onComplete }) {
  const { runHash } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/ideas/");
  };

  const handleContinue = () => {
    onComplete?.();
    navigate("/ideas/");
  };

  if (!runHash) return null;

  return (
    <Modal onClose={handleClose}>
      <IdeaGenerationProgress
        runHash={runHash}
        onContinueClick={handleContinue}
      />
    </Modal>
  );
}
